import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Inject,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-column-selector-dialog",
    templateUrl: "./column-selector-dialog.component.html",
    styleUrls: ["./column-selector-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnSelectorDialogComponent implements OnInit {
    columns: { name: string; selected: boolean }[];

    constructor(
        public dialogRef: MatDialogRef<ColumnSelectorDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { columns: { name: string; selected: boolean }[] }
    ) {}

    ngOnInit() {
        this.columns = this.data.columns;
    }

    formatCamelCase(text: string): string {
        return text.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
            return str;
        });
    }

    apply() {
        this.dialogRef.close(
            this.columns
                .filter((column) => column.selected)
                .map((column) => column.name)
        );
    }

    cancel() {
        this.dialogRef.close();
    }
}
